import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import Particles from "react-particles-js";
import "./Loader.portal.scss";

const configParticulas = {
  particles: {
    number: {
      value: 160,
      density: {
        enable: false,
      },
    },
    size: {
      value: 3,
      random: true,
      anim: {
        speed: 4,
        size_min: 0.3,
      },
    },
    line_linked: {
      enable: false,
    },
    move: {
      random: true,
      speed: 1,
      direction: "top",
      out_mode: "out",
    },
    color: {
      value: "#42ba96",
    },
  },
  interactivity: {
    events: {
      onhover: {
        enable: true,
        mode: "bubble",
      },
      onclick: {
        enable: true,
        mode: "repulse",
      },
    },
    modes: {
      bubble: {
        distance: 250,
        duration: 2,
        size: 2,
        opacity: 0,
      },
      repulse: {
        distance: 400,
        duration: 4,
      },
    },
  },
};

const LoaderPortal = ({ loginReducer, cotizacionReducer }) => {
  if (!loginReducer.Cargando && !cotizacionReducer.Cargando) {
    return null;
  }
  return ReactDOM.createPortal(
    <>
      <div className="Loader">
        <div className="Loader__Contenido">
          <div className="Loader__Contenido--Contenedor">
            <div className="row">
              <div className="col-12">
                <h1 className="text-white font-weight-bold">Por favor espere...</h1>
              </div>
            </div>
          </div>
        </div>
        <Particles className="Loader__Particulas" params={configParticulas} />
      </div>
    </>,
    document.getElementById("loader")
  );
};

const mapStateToProps = ({ loginReducer, cotizacionReducer }) => {
  return { loginReducer, cotizacionReducer };
};

export default connect(mapStateToProps, {})(LoaderPortal);
